import { useTranslation } from 'react-i18next';
import { StyleSheet, ViewStyle } from 'react-native';
import useUpdateEffect from 'react-use/lib/useUpdateEffect';

import colors from 'config/colors';
import { RemakeOrderDescription } from 'modules/OverviewScene/components/RemakeOrderDescription';
import { Order } from 'store/Orders/types';
import { ErrorText, Text } from 'components';

export interface ErrorProps {
  order: Order;
  style: ViewStyle;
  resetError: () => void;
}
export const OrderError = ({ order, style, resetError }: ErrorProps) => {
  const { t } = useTranslation();

  useUpdateEffect(() => {
    if (resetError) {
      resetError();
    }
  }, [order?.uuid]);

  return (
    <ErrorText id="overview.error" style={[styles.container, style]}>
      {order && (
        <>
          <Text
            color={colors.text.dark}
            font={'bold'}
            size={14}
            style={styles.errorText}
            align="center"
          >
            #{order.description}
            {order.remake_for_order_description && (
              <RemakeOrderDescription
                style={{ marginLeft: 4, marginTop: 4 }}
                description={order.remake_for_order_description}
              />
            )}
          </Text>
          <Text
            color={colors.gray}
            font={'medium'}
            size={14}
            style={styles.errorText}
            align="center"
          >
            {t('common.orderUUID')}: {order.uuid}
          </Text>
        </>
      )}
    </ErrorText>
  );
};

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    flexShrink: 1,
    marginTop: StyleSheet.hairlineWidth,
    minHeight: 100,
    padding: 4,
  },
  errorText: {
    marginHorizontal: 4,
    marginTop: 4,
  },
});
